import { CollaboratoreDTO } from '../../shared/dto/domain/collaboratore';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { ResponseQueryByCriteria } from '../../shared/dto/responseQueryByCriteria';
import { Observable } from 'rxjs';
import { GenericService } from 'src/app/shared/GenericService';
import { SondaggioDTO } from 'src/app/shared/dto/sondaggi/sondaggio';


@Injectable({
  providedIn: 'root'
})
export class SondaggioService extends GenericService<SondaggioDTO, number> {


  constructor(http: HttpClient) {
    super(http);
    this.url = environment.urlPrefix + '/services/rest/json/sondaggio';
  }

  public sondaggioListByList(pageNumber?: number, pageSize?: number, direction?: string, sortField?: string,
      titolo?: string,
      creatore?: CollaboratoreDTO,
      dataCreazioneDa?: Date, dataCreazioneA?: Date,
      dataScadenzaDa?: Date, dataScadenzaA?: Date,
      rispostaMultipla?: Boolean
  ): Observable<ResponseQueryByCriteria<SondaggioDTO>> {
    let params = {};
    if (pageNumber != null) params["pageNumber"] = String(pageNumber);
    if (pageSize != null) params["pageSize"] = String(pageSize);
    if (direction != null) params["direction"] = direction;
    if (sortField != null) params["sortField"] = sortField;
    
    if (titolo != null) params["titolo"] = titolo;
    if (creatore != null) params["creatore"] = creatore.id;
    if (dataCreazioneDa != null) params["dataCreazioneDa"] = dataCreazioneDa.toISOString();
    if (dataCreazioneA != null) params["dataCreazioneA"] = dataCreazioneA.toISOString();
    if (dataScadenzaDa != null) params["dataScadenzaDa"] = dataScadenzaDa.toISOString();
    if (dataScadenzaA != null) params["dataScadenzaA"] = dataScadenzaA.toISOString();
    if (rispostaMultipla != null) params["rispostaMultipla"] = rispostaMultipla;
    return this.http.get<ResponseQueryByCriteria<SondaggioDTO>>(`${this.url}/sondaggioListByList`, {
      params: params
    });
  }

  public sondaggioListPerRisposte(pageNumber?: number, pageSize?: number, direction?: string, sortField?: string,
    titolo?: string,
    collaboratore?: CollaboratoreDTO,
    dataScadenzaDa?: Date, dataScadenzaA?: Date,
    statoRispostaCollaboratore?: Boolean
  ): Observable<ResponseQueryByCriteria<SondaggioDTO>> {
    let params = {};
    if (pageNumber != null) params["pageNumber"] = String(pageNumber);
    if (pageSize != null) params["pageSize"] = String(pageSize);
    if (direction != null) params["direction"] = direction;
    if (sortField != null) params["sortField"] = sortField;
    
    if (titolo != null) params["titolo"] = titolo;
    if (collaboratore != null) params["collaboratore"] = collaboratore.id;
    if (dataScadenzaDa != null) params["dataScadenzaDa"] = dataScadenzaDa.toISOString();
    if (dataScadenzaA != null) params["dataScadenzaA"] = dataScadenzaA.toISOString();
    if (statoRispostaCollaboratore != null) params["statoRispostaCollaboratore"] = statoRispostaCollaboratore;
    return this.http.get<ResponseQueryByCriteria<SondaggioDTO>>(`${this.url}/sondaggioListPerRisposte`, {
      params: params
    });
  }

}
